<template>
  <div id>
    <v-container fluid class="pt-0">
      <v-row>
        <v-col cols="12" class="pt-0">
          <v-card style="min-height:85vh" class="admin_secondary">
            <v-card-title class="secondary white--text">
              Payment Page
              <v-spacer></v-spacer>
              <v-btn
                fab
                small
                color="success"
                class="mr-4"
                dark
                @click="save"
                v-if="modified && !loading"
              >
                <v-icon>fa-save</v-icon>
              </v-btn>
              <v-btn icon dark @click="load" :loading="loading">
                <v-icon>fa-sync</v-icon>
              </v-btn>
            </v-card-title>
            <v-container class="white--text" v-if="website">
              <v-row align="center">
                <v-col cols="12">
                  <v-text-field
                    v-model="website.payment_card_title"
                    dark
                    label="Payment Card Title"
                    @change="onChange"
                    outlined
                    hide-details
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="website.payment_card_description"
                    dark
                    label="Payment Card Description"
                    @change="onChange"
                    outlined
                    hide-details
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-subheader class="pl-0 white--text">Payment Terms</v-subheader>
                  <v-card>
                    <v-container style="height:250px">
                      <v-row>
                        <v-col cols="12">
                          <vue-editor
                            v-model="website.payment_terms"
                            @text-change="onChangeEditor"
                            style="height:150px"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <pricing-edit
                    v-model="website.payment_section.data"
                    @change="onChange"
                    :visible="true"
                  ></pricing-edit>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PricingEdit from "@/components/page/Pricing/edit";

export default {
  name: "AdminPortals",
  components: {
    pricingEdit: PricingEdit
  },
  data() {
    return {
      editorOps: {},
      website: {},
      loading: false,
      modified: false
    };
  },
  async beforeRouteLeave(to, from, next) {
    if (
      this.modified &&
      !confirm("Do you really want to leave? you have unsaved changes!")
    ) {
      return;
    } else {
      next();
    }
  },
  methods: {
    removeLink(link) {
      this.website.footer.social_links.splice(
        this.website.footer.social_links.indexOf(link),
        1
      );
      this.onChange();
    },
    addFooterLink() {
      if (!this.add_footer_link) {
        return;
      }
      this.website.footer.social_links.push(this.add_footer_link);
      this.add_footer_link = null;
      this.onChange();
    },
    onChangeEditor(delta, oldDelta) {
      console.log("edit delta ", JSON.stringify(delta));
      console.log("edit oldDelta", JSON.stringify(oldDelta));
      //!== 1) {
      if (oldDelta.ops[0].insert !== "\n") {
        if (oldDelta.ops.length !== delta.ops.length) {
          this.onChange();
        }
      }

      //}
    },
    onChange() {
      this.modified = true;
    },
    async load() {
      this.loading = true;
      try {
        this.website = await this.$api("/admin/website");
        this.modified = false;
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    },
    async save() {
      this.loading = true;
      try {
        this.website = await this.$api.patch("/admin/website", this.website);
        this.modified = false;
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    }
  },
  created() {
    this.load();
  }
};
</script>

<style>
</style>